import React, {useEffect, useState} from 'react';
import {Template} from "../../../../../components/template/template.jsx";
import {Card} from "../../../../../components/card/card.jsx";
import InputForm from "../../../../../components/input/input-form.jsx";
import Button from "../../../../../components/button/button.jsx";
import {useParams} from "react-router";
import projectUtils from "../../../../../utils/project-utils.js";
import {navigateHook} from "../../../../../hooks/use-navigate.js";
import {useQuery} from "@tanstack/react-query";
import materialKitService from "../../../../../services/web/material-kit-service.js";
import Material from "./components/material.jsx";
import SelectComponent from "../../../../../components/select/select-component.jsx";
import materialStorageService from "../../../../../services/web/material-storage-service.js";
import {FaPlus} from "react-icons/fa";
import {v4 as uuidv4} from "uuid";

const initialData = {
    id: "", description: "", storage_id: ""
}

const MaterialKitForm = () => {
    const navigate = navigateHook();
    const {id} = useParams()
    const [isLoading, setIsLoading] = useState(false)
    const [data, setData] = useState(initialData)
    const [materials, setMaterials] = useState([])

    const onChange = ({target: {value, id}}) => setData(prev => ({...prev, [id]: value}))

    const {data: kit, refetch, status, isLoading: isLoadingKit} = useQuery({
        queryKey: ['material-kit'],
        queryFn: () => materialKitService.getById(id),
        enabled: !!id
    });

    const {data: storages, isLoading: isLoadingStorages} = useQuery({
        queryKey: ['material-maintenance'],
        queryFn: () => materialStorageService.options(),
    });

    useEffect(() => {
        if (status === "success") {
            const kitNormalized = projectUtils.normalizeData(kit)
            setData(kitNormalized)
            setMaterials(kit.materials.map(k => ({...k, itemId: uuidv4()})))
        }
    }, [kit, status]);

    const save = () => {
        setIsLoading(true);

        const formData = new FormData()
        formData.append("description", data.description)
        formData.append("storage_id", data.storage_id)

        const materialsPrepared = materials.map(m => {
            if (m.material && m.quantity) return m
        }).filter(item => item !== undefined)

        if (materialsPrepared.length > 0) formData.append('materials', JSON.stringify(materialsPrepared));

        materialKitService.save(formData, id)
            .then(({data}) => {
                projectUtils.success(!id);

                if (id) {
                    refetch()
                    return;
                }

                const urlDev = `/materials/kits/form/${data.id}`;
                navigate(urlDev);

            })
            .catch((error) => {
                console.error(error);
                let message = 'Não foi possível salvar.';
                if (error.response.status !== 500) {
                    message = error.response.data.message;
                }

                projectUtils.swalErrorMessage('', message, 'Ok');
            })
            .finally(() => setIsLoading(false))
    }

    const remove = async () => {
        projectUtils.swalMessage('warning', 'Excluir', `Excluir o kit "${data.description}"?`, 'Sim', true, 'Não',
            ({isConfirmed}) => {
                if (!isConfirmed) return
                materialKitService.delete(id)
                    .then(() => {
                        projectUtils.success(true, "Excluído com sucesso")
                        navigate("/materials/kits")
                    })
                    .catch(error => {
                        console.error(error);
                        let message = 'Não foi possível excluir.';
                        if (error.response.status !== 500) {
                            message = error.response.data.message;
                        }

                        projectUtils.swalErrorMessage('', message, 'Ok');
                    });
        });
    }

    const openForm = () => {
        const urlDev = `/materials/kits/form`;
        navigate(urlDev)
    }

    return (<Template isLoading={isLoading || isLoadingKit || isLoadingStorages}>
        <Template.Header>
            <Template.Title>
                Kit de materiais
            </Template.Title>
            {
                id &&
                <Button target={"primary-outline"} onClick={openForm}>
                    <FaPlus/><span className="font-bold">Adicionar kit</span>
                </Button>
            }
        </Template.Header>
        <Template.Body>
            <Card>
                <Card.Body>
                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-8">
                            <InputForm
                                id="description"
                                name={"description"}
                                value={data.description}
                                label="Descrição *"
                                onChange={onChange}
                            />
                        </div>
                        <div className="col-span-4">
                            <SelectComponent
                                id="storage_id"
                                name="storage_id"
                                value={data.storage_id}
                                options={storages || []}
                                label={"Depósito *"}
                                onChange={(selected) => {
                                    setData(prev => ({...prev, storage_id: selected?.value}))
                                    setMaterials([])
                                }}
                            />
                        </div>
                    </div>
                </Card.Body>
            </Card>

            {
                // (data.storage_id || !!id) ?
            }
            <Material
                materials={materials}
                storage={data.storage_id}
                setMaterials={setMaterials}
                setIsLoading={setIsLoading}
            />

            <Card className={"mt-2"}>
                <Card.Body>
                    <div className="flex justify-end gap-2 w-full">
                        {id && <Button target={"danger"} onClick={remove} actionFeedbackType='delete'>Excluir</Button>}
                        <Button onClick={() => save(false)} actionFeedbackType='save'>Salvar</Button>
                    </div>
                </Card.Body>
            </Card>
        </Template.Body>
    </Template>);
};

export default MaterialKitForm;